import { useAccountCompanyId } from 'application/hooks';
import { useSubscriptionCostPresenter } from 'application/presenters';
import { useBillingRepositoryInjector } from 'application/providers/DIContainerProvider';

import { PaymentKind } from 'domain/api/graphql/generated';

const useExtendSubscriptionModalPresenter = () => {
  const companyId = useAccountCompanyId();

  const { getSubscriptionCost } = useSubscriptionCostPresenter();

  const {
    watchBillingInfo,
    licenseSubscriptionLoading,
    extendSubscription: extendSubscriptionRequest,
    launchSubscription: launchSubscriptionRequest,
  } = useBillingRepositoryInjector();

  const billingInfo = watchBillingInfo(companyId);

  const { hasInactiveLicenses, selectedPaymentKind } = billingInfo;

  const extendSubscription = async (toExtendSubscriptionLicenseIds: string[]) => {
    const result = await extendSubscriptionRequest(companyId, toExtendSubscriptionLicenseIds);

    return result;
  };

  const launchSubscription = async (toExtendSubscriptionLicenseIds: string[]) => {
    const result = await launchSubscriptionRequest(companyId, toExtendSubscriptionLicenseIds);

    return result;
  };

  return {
    hasInactiveLicenses,
    getSubscriptionCost,
    licenseSubscriptionLoading,
    isSbbolPayment: selectedPaymentKind === PaymentKind.Sbbol,
    extendSubscription,
    launchSubscription,
  };
};

export default useExtendSubscriptionModalPresenter;
